import { CompanyStaff } from "modules/companyAdmin";

const CompanyAdminStaffPage = () => <CompanyStaff />;

export default CompanyAdminStaffPage;
